/**
 * SOLID Review
 * S — Strong. One concern: one /health probe's outcome, as the client reads it.
 * O — Good. A new outcome is one more field.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. One schema.
 * D — Strong. zod only.
 */
import { z } from 'zod';

/**
 * ONE HEALTH PROBE (frontend strict-ports plan, FE5a, 2026-10-04) — the three outcomes the banner and the
 * indicator distinguish. `reachable: false` means the request itself failed. A 503 is reachable and
 * degraded, WITH the body the indicator renders; a 200 is `ok`. The body is the server's JSON object, or
 * null when there is none (or it is not an object).
 */
export const DtoHealthReport = z.object({
  reachable: z.boolean(),
  ok: z.boolean(),
  body: z.record(z.string(), z.unknown()).nullable(),
}).meta({ id: 'DtoHealthReport' });

export type IEntityHealthReport = z.infer<typeof DtoHealthReport>;
